import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/fonts.css';
import './assets/styles/index.css';

import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from '@azure/msal-react';
import 'animate.css';
import './assets/styles/adminPortal.css';
import './assets/styles/sdm.css';
import './assets/styles/enviroportal.css';
import './assets/styles/enviroportal-responsive.css';
import './assets/styles/enviroportal-ar.css';


const container = document.getElementById('root');

if (container) {
  const root = ReactDOM.createRoot(container);
  const isEnviroportal = window.location.pathname.includes("map");
  // MSAL configuration from environment variables
  const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
      authority: process.env.REACT_APP_MSAL_AUTHORITY,
      redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
    },
  };

  const msalConfigEnviroportal = {
    auth: {
      clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
      authority: process.env.REACT_APP_MSAL_AUTHORITY,
      redirectUri: process.env.REACT_APP_MSAL_ENVIROPORTAL_REDIRECT_URI,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
    },
  };
  const msalInstance = new PublicClientApplication(isEnviroportal ? msalConfigEnviroportal : msalConfig);
 
  //  Initialize MSAL before anything else
  msalInstance.initialize()
    .then(() => {
      //  Now handle redirect result
      return msalInstance.handleRedirectPromise();
    })
    .then((response) => {
      if (response) {
      
        // Safe to set after successful login
        localStorage.setItem("isInternalUser", 1);
      } 

   
    })
    .catch((error) => {
      console.error("Redirect handling failed:", error);
    
    });



  root.render(
    // <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </MsalProvider>
    // </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
} else {
  console.error("Root element not found");
}
